import "./ShareIconsDialog.css";
import iconsSpecs from "./share_icons_specs";
import React, { useState, useRef, useEffect } from 'react';


function ShareIconsDialog({ onClose }) {
    const [filter, setFilter] = useState('');
    const modalRef = useRef(null);
    const [fixedHeight, setFixedHeight] = useState(null);

    // When the modal is opened, measure its height
    useEffect(() => {
        if (modalRef.current) {
            // Measure the height on initial render
            setFixedHeight(modalRef.current.clientHeight);
        }
    }, []); // [] ensures it runs only once when the modal mounts

    // Close the modal if clicking outside the modal content.
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
  
    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });

    // Convert filter to lowercase for case-insensitive matching
    const normalizedFilter = filter.toLowerCase();

    // Filter iconSpecs entries based on the key matching the normalized filter
    const filteredEntries = iconsSpecs.filter(item =>
        item.lowercase.includes(normalizedFilter)
    );

    const shareUrl = "https://self-affirmations.net"
    return (
        <>
            <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div className="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto" onClick={onClose}>
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    {/* Add onClick on the modal content to prevent propagation */}
                        <div
                            ref={modalRef}
                            className="relative transform overflow-hidden rounded-lg bg-gray-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
                            onClick={(e) => e.stopPropagation()}
                            // Apply the fixed height if measured, otherwise no inline height.
                            style={fixedHeight ? { height: `${fixedHeight}px` } : {}}
                        >
                            <div
                                // ref={modalRef}
                                // className="relative bg-gray-800 rounded shadow-lg max-w-[600px] max-h-[500px] w-full"
                                className="relative bg-gray-800 rounded shadow-lg w-full flex flex-col h-full"
                            >
                                {/* Close Button */}
                                
                                <input
                                    className="w-[95%] m-3 rounded-full"
                                    type="text"
                                    placeholder=" Filter icons..."
                                    value={filter}
                                    onChange={(e) => setFilter(e.target.value)}
                                    style={{ marginBottom: "1rem", padding: "0.5rem", fontSize: "1rem" }}
                                />
                                <ul id="share-icons-list">
                                    {filteredEntries.map(({ lowercase, button: ShareButton, icon: Icon, name }) => (
                                        <React.Fragment key={lowercase}>
                                        <ShareButton htmlTitle={name} url={shareUrl}>
                                            <Icon round={true} className="m-2" size={48} />
                                        </ShareButton>
                                        </React.Fragment>
                                    ))}
                                </ul>
                                <div className="px-4 py-3 flex flex-row-reverse px-6 bg-gray-900 mt-auto">
                                    <button
                                        id="close-button"
                                        onClick={onClose}
                                        className="text-white bg-gray-900 px-4 py-2"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShareIconsDialog;
